import { gql } from '@apollo/client';

const UPDATE_HOLTER_PROFILE_MUTATION = gql`
  mutation updateHolterProfile($input: UpdateHolterProfileInput!) {
    updateHolterProfile(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPDATE_HOLTER_PROFILE_MUTATION;
